import React, {Component} from 'react'
import {
    ExpansionPanel,
    Typography,
    ExpansionPanelDetails,
    ExpansionPanelActions,
    ExpansionPanelSummary,
    Tooltip,
    Button,
    ListSubheader,
    List,
    ListItem,
    FormControl,
    ListItemText,
    Checkbox,
    InputLabel,
    Select,
    MenuItem,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Avatar,
    LinearProgress
} from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

export default class AddTracks extends Component {
    constructor(props) {
        super(props)
        this.state = {
            selectedTracksIds: [],
            saveConfirm: false,
            clearConfirm: false
        }
    }

    onSubmit = async () => {
        const tracksToAdd = this.props.tracks.filter((t) =>
            this.state.selectedTracksIds.includes(t.uuid)
            || this.state.selectedTracksIds.includes(t.track_id)
        ).filter(t => !this.props.registeredTracks.find(rtr => rtr.track_id === t.uuid || rtr.track_id === t.track_id))
        await this.props.submit(tracksToAdd)
        this.hideSaveDialog();
        this.setState({selectedTracksIds: []})
    };

    setChosenTrack = (track) => {
        const {selectedTracksIds} = this.state
        if (selectedTracksIds.includes(track.uuid) || selectedTracksIds.includes(track.track_id)) {
            this.setState({
                selectedTracksIds: this.props.genre === 0 ? selectedTracksIds.filter((t) => t !== track.track_id) : selectedTracksIds.filter((t) => t !== track.uuid)
            })
        } else {
            this.setState({selectedTracksIds: [...selectedTracksIds, track.uuid || track.track_id]})
        }
    }

    onClearAll = () => {
        this.setState({selectedTracksIds: [], clearConfirm: false})
    }

    hideSaveDialog = () => {
        this.setState({saveConfirm: false})
    };
    openSaveDialog = () => {
        this.setState({saveConfirm: true})
    }

    hideClearDialog = () => {
        this.setState({clearConfirm: false})
    };
    openClearDialog = () => {
        this.setState({clearConfirm: true})
    }

    onChangeGenre = (e) => {
        this.setState({selectedTracksIds: []});
        this.props.changeGenre(e)
    }

    render() {
        const {selectedTracksIds} = this.state;
        const {tracks, genres, genre, loading} = this.props;
        return (
            <React.Fragment>
                <Dialog
                    key={'saveDialog'}
                    open={this.state.saveConfirm}
                    onClose={this.hideSaveDialog}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{"Add tracks?"}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Are you sure you want add this tracks?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.hideSaveDialog} color="primary">
                            Cancel
                        </Button>
                        <Button onClick={this.onSubmit} color="primary" autoFocus>
                            Add
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    key={'clearDialog'}
                    open={this.state.clearConfirm}
                    onClose={this.hideClearDialog}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{"Clear tracks"}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Are you sure you want clear all registered tracks?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.hideClearDialog} color="primary">
                            Cancel
                        </Button>
                        <Button onClick={this.onClearAll} color="primary" autoFocus>
                            Clear
                        </Button>
                    </DialogActions>
                </Dialog>
                <ExpansionPanel style={{width: '100%', borderRadius: 0}}>
                    <ExpansionPanelSummary
                        expandIcon={<ExpandMoreIcon/>}
                        aria-controls="panel1bh-content"
                        id="panel1bh-header"
                    >
                        <Typography style={{marginRight: 5}}>Add tracks</Typography>
                        <Typography style={{color: 'rgba(0, 0, 0, 0.54)'}}>Selected
                            tracks: {this.state.selectedTracksIds.length}</Typography>
                    </ExpansionPanelSummary>
                    {loading ? <LinearProgress style={{width: '100%'}}/> : null}
                    <ExpansionPanelDetails style={{display: 'flex', overflow: 'auto', flexDirection: 'row'}}>
                        <List
                            className={"list"}
                            disablePadding
                            subheader={
                                <ListSubheader disableSticky component="div" id="nested-list-subheader">
                                    Tracks:
                                </ListSubheader>
                            }
                            style={{maxHeight: '60vh', minWidth: '60%', width: 'auto', overflow: 'scroll'}}>
                            {tracks.map((track) => {
                                const checked = selectedTracksIds.includes(track.uuid) || selectedTracksIds.includes(track.track_id)
                                return (
                                    <ListItem onClick={() => this.setChosenTrack(track)} button>
                                        <Checkbox
                                            checked={checked}
                                            inputProps={{'aria-label': 'primary checkbox'}}
                                        />
                                        <Avatar
                                            alt="Remy Sharp"
                                            variant={'square'}
                                            style={{marginRight: 10}}
                                            src={`https://res.cloudinary.com/tweedl-dev/image/upload/w_300,h_300,c_scale/${track.cover_art}.jpg`}/>
                                        <ListItemText
                                            primary={`${track.name || track.track_name}`}
                                            secondary={`by ${track.artist_name}`}
                                        />
                                    </ListItem>
                                )
                            })}
                            {!this.props.lastPage && !loading
                                ? <Button onClick={this.props.nextPage}>More</Button>
                                : null}
                        </List>
                        <FormControl>
                            <InputLabel id="demo-simple-select-label">Genre</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={genre}
                                onChange={this.onChangeGenre}
                            >{genres.map(g => {
                                return (
                                    <MenuItem value={g.id}>{g.name}</MenuItem>
                                )
                            })}
                            </Select>
                        </FormControl>
                    </ExpansionPanelDetails>
                    <ExpansionPanelActions>
                        <Tooltip title={"Save tracks"}>
                            <span>
                            <Button onClick={this.openSaveDialog}
                            >Add</Button>
                            </span>
                        </Tooltip>
                        <Tooltip title={"Clear all"}>
                            <span>
                            <Button onClick={this.openClearDialog}
                            >Clear selected</Button>
                            </span>
                        </Tooltip>
                    </ExpansionPanelActions>
                </ExpansionPanel>
            </React.Fragment>
        )
    }
}